export default __webpack_public_path__ + "e4f07e6029cec5229f6b2acee5c56e84.svg";